import { captureException } from '@sentry/node';
import { Response } from 'express';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { getClientAll } from '@r1-frontend/entities/stores/auth/actions/getClientAll';
import { catch401 } from '@r1-frontend/entities/stores/auth/helpers/catch401';
import { TState } from '@r1-frontend/entities/stores/auth/reducer';

/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export const loginByAccessToken = (agreementNumber?: string, response?: Response): (dispatch: ThunkDispatch<TState, void, AnyAction>) => Promise<{
    isValidAccessToken: boolean,
}> => {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>) => {
        try {
            await dispatch(getClientAll(response, agreementNumber));

            return { isValidAccessToken: true };
        } catch (e) {
            if (catch401(e)) {
                return { isValidAccessToken: false };
            }

            captureException(e);
            return { isValidAccessToken: false };
        }
    };
};
